<template>
    <div class="users-manager-wrap px-2 py-2 border">
        <div class="title-wrap border-bottom mb-3">
            <h1>Управление правами пользователей</h1>
        </div>
        <div class="w-100 form-wrap">

            <div class="list-wrap" v-if="usersList.length > 0">
                <div class="pagination-wrap" v-if="pageCount > 1">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalCount"
                            :per-page="perPage"
                            :disabled="isLoading"
                            size="sm"
                    ></b-pagination>
                </div>

                <b-table
                        striped
                        hover
                        small
                        id="users-list"
                        :items="usersList"
                        :fields="fields"
                >
                    <template v-slot:cell(actions)="row">
                        <b-button @click="showUserEditModal(row)" size="sm">
                            <font-awesome-icon icon="user-edit"></font-awesome-icon>
                        </b-button>
                    </template>
                </b-table>

                <div class="pagination-wrap" v-if="pageCount > 1">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalCount"
                            :per-page="perPage"
                            :disabled="isLoading"
                            size="sm"
                    ></b-pagination>
                </div>

                <div class="text-right">Страница: {{ currentPage }} / {{ pageCount }}</div>
            </div>
        </div>

        <b-modal id="userParams" hide-footer title="Настройки для пользователя" v-model="showUserParams">
            <div class="rights-wrap">
                <div># {{currentUser.id}}</div>
                <div>
                    <strong>Имя пользователя:</strong> {{currentUser.username}}
                </div>
                <div>
                    <strong>Имя:</strong> {{currentUser.profile_name}}
                </div>
                <div>
                    <strong>Контакты:</strong> {{currentUser.email}} / {{currentUser.phone}}
                </div>
                <b-form-group label="Права пользователя">
                    <b-form-checkbox-group
                            v-model="currentUser.roles"
                            :options="availableUserRights"
                    ></b-form-checkbox-group>
                </b-form-group>

                <div>
                    <b-button class="float-right" variant="danger" @click="setUserRoles()">Обновить</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss">
    .profile-wrap {
        background-color: #f2f2f2;
    }
    .title-wrap h1 {
        line-height: 85px;
    }
    th[role="columnheader"] {
        border-top: none!important;
    }
    .left-menu-wrap .router-link-active {

    }
</style>

<script>
  import mixinUtils from "@/components/mixinUtils";
  import { orgRights } from "@/helpers/variables";
  export default {
    name: 'users-manager',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {

      },
      currentUser: {
        id: null,
        username: null,
        email: null,
        phone: null,
        profile_name: null,
        roles: [],
      },
      fields: [
        {
          key: 'id',
          label: '#',
          sortable: false
        },
        {
          key: 'username',
          label: 'Имя пользователя',
          sortable: false
        },
        {
          key: 'email',
          label: 'Email',
          sortable: false,
        },
        {
          key: 'phone',
          label: 'Телефон',
          sortable: false,
        },
        {
          key: 'profile_name',
          label: 'Имя',
          sortable: false,
        },
        {
          key: 'actions',
          label: '',
        }
      ],
      showUserParams: false,
      availableUserRights: [],
      usersList: [],
      isLoading: false,
      currentPage: 1,
      pageCount: 1,
      totalCount: null,
      perPage: 20,
    }),
    methods: {
      showUserEditModal(row) {
        const normalizedRules = []
        if (row.item.roles !== undefined) {
          for (let i = 0; i < row.item.roles.length; i++) {
            if (row.item.roles[i] !== null && row.item.roles[i] !== undefined) {
              normalizedRules.push(row.item.roles[i])
            }
          }
        }
        this.currentUser = row.item
        this.currentUser.roles = normalizedRules
        this.showUserParams = true
      },
      setUserRoles () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        contex.apiCall(`roles/set-pharm-company-roles`, 'post', contex.currentUser)
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно обновлены`, {
                title: 'Управление пользователями',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              for (let i = 0; i < contex.usersList.length; i++) {
                let curUser = contex.usersList[i]
                if (curUser.id !== contex.currentUser.id) {
                  continue;
                }

                curUser = {
                  id: contex.currentUser.id,
                  username: contex.currentUser.username,
                  email: contex.currentUser.email,
                  phone: contex.currentUser.phone,
                  profile_name: contex.currentUser.profile_name,
                  roles: contex.currentUser.roles,
                }
              }

              contex.showUserParams = false
            }

            contex.isLoading = false
          })
        .catch(function (error) {
          console.error(error)
          contex.isLoading = false

          contex.$bvToast.toast(`${error.message}`, {
            title: 'Управление пользователями',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })
        })
      },
        getUsers () {
          const contex = this
          if (contex.isLoading) return;

          contex.isLoading = true
          contex.apiCall(`users/get-pharm-company-users?page=${contex.currentPage}&per-page=${contex.perPage}`, 'post', contex.form)
            .then(function (response) {
              if (response.data.status === 200) {
                contex.$bvToast.toast(`Данные успешно получены`, {
                  title: 'Управление пользователями',
                  autoHideDelay: 5000,
                  variant: 'success',
                  appendToast: false,
                  toaster: 'b-toaster-bottom-right',
                })
              }

              contex.usersList = []
              for (let i = 0; i < response.data.items.length; i++) {
                const data = response.data.items[i]
                const user = {
                  id: data.id,
                  username: data.username,
                  email: data.email,
                  phone: data.phone,
                  profile_name: data.profile_name,
                  roles: JSON.parse(data.roles),
                }
                contex.usersList.push(user)
              }

              contex.currentPage = response.data._meta.currentPage
              contex.pageCount = response.data._meta.pageCount
              contex.totalCount = response.data._meta.totalCount

              contex.isLoading = false
            })
          .catch(function (error) {
            console.error(error)
            contex.isLoading = false
          })
        }
    },
    mounted() {
      if (!this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/login'})
      }

      const context = this
      context.getUsers()

      context.availableUserRights = orgRights

    },
    watch: {
      currentPage: {
        // eslint-disable-next-line no-unused-vars
        handler: function(newVal, oldVal) {
            this.getUsers()
        }
      }
    },
    computed: {
      computedUsersList () {
        return this.usersList
      }
    }
  }
</script>